var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.containerClasses},[_c('vue-monthly-picker',{ref:"picker",staticClass:"form-control-month",attrs:{"monthLabels":_vm.monthLabels,"dateFormat":_vm.dateFormat},on:{"input":_vm.updated},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }